import { Component } from '@angular/core';
import { ApiService } from './services/api/api.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    title = 'LionsgateSphere-fe';

    constructor(
        public apiService: ApiService 
    ) {
        // this.apiService.getApiData1()

        // this.apiService.loadXML('assets/json/MOVSP.xml')
        
    }
}
